import React, { Component } from "react";
import Family from "../HocComponent";

// Member details for ChildA (Infant)
const memberDetails = {
  type: "infant",
  myage: "2months",
  rashi: "vrishik"
};

/**
 * ChildA family member component - represents an infant
 * Enhanced by the Family HOC with age management and modal functionality
 */
class ChildAHoc extends Component {
  render() {
    const { mydetail, age, incrementAge } = this.props;
    const details = { ...mydetail };

    return (
      <div className="family-member">
        <div className="py-4">
          <div className="justify-content-center">
            <div className="">
              <div className="card">
                <div className="card-header text-left">
                  <h1 className="card-title mb-1">
                    <i className="fas fa-baby mr-2"></i>
                    ChildA's World
                  </h1>
                  <small className="text-light">Infant Family Member</small>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-8 text-left">
                      <div className="profile-section mb-4">
                        <div className="profile-avatar mb-3">
                          <div className="avatar-circle bg-primary text-white d-inline-flex align-items-center justify-content-center">
                            <i className="fas fa-baby fa-2x"></i>
                          </div>
                        </div>
                        <h2 className="text-dark">My name is ChildA</h2>
                        <h3 className="text-muted">Current Age: <span className="badge badge-primary badge-lg">{age}</span></h3>
                      </div>

                      <div className="action-section mb-4">
                        <button
                          onClick={incrementAge}
                          className="btn btn-primary btn-lg px-4"
                          type="button"
                          aria-label={`Increment ChildA's age, currently ${age}`}
                        >
                          <i className="fas fa-plus-circle mr-2"></i>
                          Grow Up: {age}
                        </button>
                      </div>

                      <h3 className="text-primary mt-4 mb-3">Welcome to My World</h3>
                      <p className="lead">
                        Welcome to the adorable world of our youngest family member!
                        Every day brings new discoveries and endless joy. This component
                        showcases playful design elements perfect for representing an infant's
                        cheerful and curious nature.
                      </p>

                      <h4 className="text-primary mt-4 mb-3">Infant Characteristics</h4>
                      <ul className="list-unstyled">
                        <li className="mb-2">
                          <i className="fas fa-check-circle text-success mr-2"></i>
                          Playful and colorful interface design
                        </li>
                        <li className="mb-2">
                          <i className="fas fa-check-circle text-success mr-2"></i>
                          Cheerful icons and visual elements
                        </li>
                        <li className="mb-2">
                          <i className="fas fa-check-circle text-success mr-2"></i>
                          Growth-focused interaction patterns
                        </li>
                        <li className="mb-2">
                          <i className="fas fa-check-circle text-success mr-2"></i>
                          Enhanced by Family HOC pattern
                        </li>
                      </ul>

                      <div className="quote-section mt-4 p-3 bg-light rounded">
                        <p className="mb-0 text-dark">
                          <i className="fas fa-quote-left mr-2 text-primary"></i>
                          Every day brings new discoveries and endless joy.
                          Watch me grow and learn in this beautiful journey of life!
                          <i className="fas fa-quote-right ml-2 text-primary"></i>
                        </p>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="bg-light p-4 rounded">
                        <h3 className="text-primary mb-3">
                          <i className="fas fa-info-circle mr-2"></i>
                          Member Details
                        </h3>
                        <div className="member-details">
                          <div className="detail-item mb-3 p-3 bg-white rounded">
                            <h4 className="h5 mb-1">
                              <i className="fas fa-baby-carriage text-primary mr-2"></i>
                              Type
                            </h4>
                            <span className="text-dark text-capitalize">{details.type}</span>
                          </div>
                          <div className="detail-item mb-3 p-3 bg-white rounded">
                            <h4 className="h5 mb-1">
                              <i className="fas fa-calendar-alt text-primary mr-2"></i>
                              Age Category
                            </h4>
                            <span className="text-dark">{details.myage}</span>
                          </div>
                          <div className="detail-item mb-3 p-3 bg-white rounded">
                            <h4 className="h5 mb-1">
                              <i className="fas fa-star text-primary mr-2"></i>
                              Rashi
                            </h4>
                            <span className="text-dark text-capitalize">{details.rashi}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-5 text-left">
                    <h3 className="text-primary mb-3">Development Milestones</h3>
                    <p>
                      ChildA represents the infant stage of development, showcasing how the Family HOC
                      adapts to different life stages while maintaining consistent functionality.
                    </p>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="feature-card p-3 border rounded mb-3">
                          <h4 className="h5 text-primary">
                            <i className="fas fa-seedling mr-2"></i>
                            Growth Tracking
                          </h4>
                          <p className="mb-0 text-muted">
                            Monitor development progress with age increment functionality and milestone tracking.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="feature-card p-3 border rounded mb-3">
                          <h4 className="h5 text-primary">
                            <i className="fas fa-heart mr-2"></i>
                            Playful Design
                          </h4>
                          <p className="mb-0 text-muted">
                            Colorful and engaging interface elements designed for the youngest family member.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="feature-card p-3 border rounded mb-3">
                          <h4 className="h5 text-primary">
                            <i className="fas fa-smile mr-2"></i>
                            Joyful Experience
                          </h4>
                          <p className="mb-0 text-muted">
                            Optimistic and cheerful user experience reflecting the joy of early childhood.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Set display name for debugging
ChildAHoc.displayName = 'ChildAHoc';

export default Family(ChildAHoc, memberDetails);